import React, {
  useEffect,
  useState,
  Fragment,
  useContext,
  useRef,
} from "react";
import ReactModal from "react-modal";
import { deleteAccount } from "../api/userApi";
import UserContext from "../contexts/user-context";

const customStyles = {
  content: {
    // top: "50%",
    // left: "50%",
    // right: "auto",
    // bottom: "auto",
    // marginRight: "-50%",
    // transform: "translate(-50%, -50%)",

    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
};

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
ReactModal.setAppElement("#root");
export default function NewProfile(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [error, setError] = useState("");
  const { user, handleUserSignOut } = useContext(UserContext);

  async function onDelete() {
    deleteAccount()
      .then((res) => {
        if (res && res.data.success) {
          setIsOpen(false);
          handleUserSignOut();
        }
      })
      .catch((e) => {
        setError(
          "There is an error on our server. Please contact us at hello@squishalert.com."
        );
      });
  }
  return (
    <div
      className="row justify-content-center"
      style={{ height: "80vh", position: "relative" }}
    >
      <div className="col-md-10">
        <h1>Hi {user.name}</h1>
        <div>
          <a className="link-sucess" onClick={() => setIsOpen(true)}>
            Permanently delete my account
          </a>
        </div>
        <div>
          <button
            className="btn btn-light"
            onClick={handleUserSignOut}
            style={{
              borderRadius: 30,
              padding: 10,
            }}
          >
            Sign out
          </button>
        </div>
      </div>
      <ReactModal
        isOpen={modalIsOpen}
        // onAfterOpen={afterOpenModal}
        // onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        className="col-md-6"
      >
        <div
          style={{
            boxShadow: "2px 2px 10px",
            padding: 20,
            borderRadius: 20,
            backgroundColor: "white",
            maxWidth: "500px",
          }}
        >
          <h2>Delete confirmation</h2>
          {/* <button onClick={closeModal}>close</button> */}
          <div>
            You are about to permantly delete your account associated with phone
            number <u>{user.phone}</u>
          </div>
          <div>
            By confirming, all your information including your name, phone
            number and subscriptions will be permanently erased from our system.{" "}
          </div>
          {error !== "" && <p className="text-danger">{error}</p>}
          <div className="d-flex flex-row my-3 ">
            <button className="btn btn-danger mr-3" onClick={onDelete}>
              Delete my account
            </button>
            <button
              className="btn btn-outline-secondary"
              onClick={() => setIsOpen(false)}
            >
              Cancel deleting
            </button>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
